import React from 'react';

/**
 * Shared Sleeper imagery for the shell — every league, team, manager, and
 * player display should carry its avatar (user directive 2026-06-11).
 */

/** League/team/manager avatar. Pass `url` (full URL) or `id` (Sleeper avatar id).
 *  League-uploaded avatars arrive as full URLs in the `avatar` field — pass
 *  them through untouched instead of prefixing the thumbs base. */
export const SleeperAvatar = ({ url, id, name, size = 32, radius = '50%' }) => {
  const raw = url || id;
  const src = raw
    ? (String(raw).startsWith('http') ? raw : `https://sleepercdn.com/avatars/thumbs/${raw}`)
    : null;
  const fallback = (
    <span
      style={{
        width: size, height: size, borderRadius: radius, background: 'var(--ft-surface-hover)',
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center', flex: 'none',
        fontSize: Math.max(10, size * 0.34), fontWeight: 700, color: 'var(--ft-ink-2)',
      }}
    >
      {(name || '?').slice(0, 1).toUpperCase()}
    </span>
  );
  if (!src) return fallback;
  return (
    <img
      src={src}
      alt=""
      style={{ width: size, height: size, borderRadius: radius, objectFit: 'cover', flex: 'none' }}
      onError={(e) => { e.currentTarget.style.display = 'none'; }}
    />
  );
};

/** Player headshot (Sleeper player id). */
export const PlayerHeadshot = ({ playerId, size = 26 }) => (
  <img
    src={`https://sleepercdn.com/content/nfl/players/thumb/${playerId}.jpg`}
    alt=""
    style={{
      width: size, height: size, borderRadius: '50%', objectFit: 'cover', flex: 'none',
      background: 'var(--ft-surface-hover)',
    }}
    onError={(e) => { e.currentTarget.src = '/logo-avatar.png'; }}
  />
);
